import createDataContext from './createDataContext'

interface StateType {
    username: string,
    userType: any
}

interface ActionType {
    payload: any,
    type: string
}

const initialState: StateType = {
    username: '',
    userType: ''
}

const reducer = (state, action: ActionType) => {
    
    switch(action.type)
    {
        case 'setUsername': return { ...state, username: action.payload }

        case 'setUserType': return { ...state, userType: action.payload }

        default: return state
    }

}

const setUserType = dispatch => {

    return (userType: any, callback?) => {

        dispatch({ type: 'setUserType', payload: userType })

        callback?.()

    }

}

const setUsername = dispatch => {

    return (username: string, callback?) => {

        dispatch({ type: 'setUsername', payload: username })

        callback?.()

    }

}

export interface UserInterface {
    state: StateType,
    setUsername: (username: string, callback?) => void,
    setUserType: (userType: any, callback?) => void
}

export const { Context: UserContext, Provider: UserProvider } = createDataContext(reducer,
    { setUsername, setUserType },
    initialState)
